import { fetchProjectById } from './fetchProjectByIdThunk';
export default fetchProjectById;
